<template>
    <div>
		<vs-dialog
			:width="alert.width"
			v-model="alert.show"
			blur
			:not-close="noclose"
            scroll
            overflow-hidden
            auto-width
			prevent-close>
			<template #header v-if="alert.title !== null">
				<h4 class="not-margin">
					{{ $t(alert.title) }}
				</h4>
			</template>

			<div v-if="alert.type === 'term'">
				<span class="text-center">
					<mu-col class="text-center">
						<TermContact />
					</mu-col>
				</span>
			</div>

			<slot name="message"></slot>
			<slot name="custom"></slot>
			<slot name="custom-buttons"></slot>

            <template #footer v-if="alert.footer">
                <div class="row mt-1" v-if="['logged', 'register'].indexOf(alert.type) === -1">
                    <div class="col text-center">

						<mu-button flat color="red" @click="closeAlert(null)" class="mt-1 mb-1">
                            {{ alert.cancel_label == null ? `${$tc('button_action.close')}` : alert.cancel_label }}
                        </mu-button>
                        <mu-button flat color="success" @click="closeAlert(alert.method)" class="mt-1 mb-1">
                            {{ alert.confirm_label == null ? `${$t('button_action.continue')}` : alert.confirm_label }}
                        </mu-button>
                    </div>
                </div>
            </template>
			<template #footer else-if="alert.type === 'term'">
				<div class="col text-center">
					<mu-button flat color="red" @click="closeAlert(null)" class="mt-1 mb-1">
                        {{ alert.cancel_label == null ? `${$tc('button_action.close')}` : alert.cancel_label }}
                    </mu-button>
                </div>
			</template>
		</vs-dialog>

    </div>
</template>

<script>
	// HELPERS
	import _GlobalHelper from '@/store/helpers/global'
	// VUEX
	import { mapGetters, mapMutations } from 'vuex'
	// COMPONENTS
	import TermContact from '@/components/TermCondition/Contact'

    export default {
		name: 'alert-custom',
		components: {
			TermContact: TermContact
		},
		props: { 
			noclose: {
				type: Boolean,
				default: () => {
					return true
				}
			}
		},
		data() {
			return {
				show: false
			}
		},
        computed: {
        	...mapGetters({
				alert: _GlobalHelper.getters.alert_custom
			}),
		},
		methods: {
			...mapMutations({
				setAlertCustom: _GlobalHelper.mutations.setAlertCustom
			}),

			getRegister () {
                window.open('https://viajero.vallartaplus.mx/', '_blank')
            },

			closeAlert(method) {

				this.setAlertCustom({
					show: false,
					confirm_label: null,
					cancel_label: null,
					title: null,
					message: null,
					method: method,
                    footer: true,
					noclose: true
				})
			}
		},
    }
</script>

<style lang="scss">
	.mu-dialog-title {
		color: #005296;
		justify-content: space-around;
		border-top: black;
	}
	.mu-dialog-fullscreen {
		max-width: 78% !important;
		max-height: 86% !important;
		position: initial;
	}
	.mu-dialog-scrollable .mu-dialog-body {
		height: inherit;
	}
</style>
